function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1111{fill:#8f9bb3;}.cls-2222{fill:#01b6ce;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1111",
  d: "M9.78,0A1.2,1.2,0,0,1,11,1.18,1.2,1.2,0,0,1,9.78,2.36H3.67A1.21,1.21,0,0,0,2.44,3.55v18.9a1.21,1.21,0,0,0,1.23,1.19H9.78a1.18,1.18,0,1,1,0,2.36H3.67A3.61,3.61,0,0,1,0,22.45V3.55A3.61,3.61,0,0,1,3.67,0Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2222",
  d: "M16.28,7.38l5.33,5.2a1.28,1.28,0,0,1,0,1.84l-5.33,5.2a1.36,1.36,0,0,1-1.89,0,1.28,1.28,0,0,1,0-1.81l0,0L17.24,15H7.93C7.42,15,7,14.33,7,13.5s.42-1.5.93-1.5h9.31L14.39,9.22a1.28,1.28,0,0,1,0-1.81l0,0A1.36,1.36,0,0,1,16.28,7.38Z"
});

function SvgSingOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingOut);
export default __webpack_public_path__ + "static/media/sing-out.b9aa974c.svg";
export { ForwardRef as ReactComponent };